import { DocLayout } from './DocLayout';

export default function DocVoluntari() {
  return (
    <DocLayout title="Voluntari">
      <h2>Prezentare generală</h2>
      <p>
        Sistemul de voluntariat permite gestionarea voluntarilor pentru fiecare activitate.
        Voluntarii pot aplica prin platforma publică sau pot fi adăugați de staff.
        Echipa staff aprobă, respinge sau retrage aprobarea aplicațiilor.
      </p>

      <h2>Rolul de voluntar</h2>
      <ul>
        <li><strong>Activare de către staff</strong> — din pagina Utilizatori, toggle-ul de voluntar sau butonul de aprobare pentru cererile primite.</li>
        <li><strong>Auto-activare la crearea contului staff</strong> — utilizatorii staff care au data nașterii completată și cel puțin 15 ani primesc automat rolul de voluntar.</li>
        <li><strong>Cerere de la utilizator</strong> — utilizatorii pot solicita rolul de voluntar din pagina lor de cont. Cererea necesită data nașterii și vârstă minimă 15 ani.</li>
        <li><strong>Bio voluntar</strong> — voluntarii pot completa un text despre ei în profil. Acest text este vizibil staff-ului și este obligatoriu la aplicarea pentru activități.</li>
      </ul>

      <h2>Setări voluntari pe activitate</h2>
      <p>În formularul de editare al activității, secțiunea <strong>Voluntari</strong> permite:</p>
      <ul>
        <li><strong>Deschis pentru aplicații</strong> — activează/dezactivează posibilitatea de a aplica ca voluntar.</li>
        <li><strong>Capacitate voluntari</strong> — numărul maxim de voluntari aprobați. Gol = nelimitat.</li>
        <li><strong>Instrucțiuni</strong> — text ghid pentru voluntari.</li>
        <li><strong>Echipe</strong> — creează echipe cu nume, iconiță, culoare și capacitate proprie.</li>
        <li><strong>Coordonatori</strong> — asignează persoane care primesc notificări la aplicații noi și pot aproba/respinge.</li>
        <li><strong>Vizibil pentru voluntari</strong> — activitatea apare în lista voluntarilor chiar dacă nu e publicată public.</li>
      </ul>

      <h2>Statusuri aplicații</h2>
      <ul>
        <li><strong>În așteptare</strong> — aplicația a fost trimisă, necesită aprobare.</li>
        <li><strong>Aprobat</strong> — voluntarul a fost acceptat.</li>
        <li><strong>Respins</strong> — aplicația a fost respinsă de staff.</li>
        <li><strong>Retras</strong> — voluntarul s-a retras singur din activitate.</li>
      </ul>
      <p>
        Staff-ul poate reveni la orice status anterior (ex: mută un voluntar respins înapoi la „În așteptare" sau „Aprobat").
        Toate schimbările de status sunt înregistrate într-un jurnal intern.
      </p>

      <h2>Acțiuni staff</h2>
      <ul>
        <li><strong>Aprobă / Respinge</strong> — pentru aplicații în așteptare.</li>
        <li><strong>Retrage aprobarea</strong> — pentru voluntari deja aprobați. Voluntarul primește email.</li>
        <li><strong>Revenire la stare anterioară</strong> — mută voluntarul la „În așteptare" sau „Aprobat".</li>
        <li><strong>Schimbă echipa</strong> — din dropdown-ul de echipă din tabel.</li>
        <li><strong>Note interne</strong> — adaugă note vizibile doar staff-ului.</li>
      </ul>

      <h2>Capacitate</h2>
      <p>
        Capacitatea se verifică la aprobare (nu la aplicare). Doar voluntarii aprobați contorizează.
        Dacă există echipe cu capacitate proprie, aprobarea e blocată când echipa e plină.
      </p>

      <h2>Exporturi</h2>
      <ul>
        <li><strong>Printează</strong> — generează o pagină de printare cu voluntarii.</li>
        <li><strong>Export CSV</strong> — descarcă lista de voluntari în format CSV.</li>
      </ul>
      <p>Ambele respectă filtrele aplicate (status, echipă, căutare).</p>

      <h2>Notificări email</h2>
      <ul>
        <li>Voluntarul aprobat primește email de confirmare.</li>
        <li>Voluntarul cu aprobarea retrasă primește email.</li>
        <li>Coordonatorii primesc email la fiecare aplicație nouă.</li>
        <li>Coordonatorii sunt notificați când un voluntar aprobat se retrage.</li>
      </ul>

      <h2>Vizibilitate voluntari</h2>
      <p>
        Voluntarii aprobați care au consimțit la vizibilitate pot fi văzuți de alți voluntari care vizualizează activitatea.
        Consimțământul se dă la momentul aplicării prin checkbox-ul GDPR.
      </p>

      <h2>Invitații</h2>
      <p>
        Pentru activitățile marcate ca „doar cu invitație", participanții pot fi invitați prin email.
        Consultă secțiunea de invitații din pagina activității pentru detalii.
      </p>

      <h2>Exclusivitate participant / voluntar</h2>
      <p>
        Un utilizator nu poate fi simultan participant și voluntar (în așteptare sau aprobat) la aceeași activitate.
        Dacă un voluntar este respins sau se retrage, poate apoi să se înregistreze ca participant.
      </p>
    </DocLayout>
  );
}
